import { react2angular } from 'react2angular';
import MlsFilterDropdown from '../../components/UniversalSearch/MlsFilterDropdown';
import QueueList from './queue/QueueList.tsx';
import QueuePreferencesModal from './queue/QueuePreferencesModal.tsx';
import BrokerageGrouping from './brokerage_settings/Pages/BrokerageGrouping.tsx';
import Loading from '../react-common/Loading.tsx';

angular
  .module('bb.answering', ['ngRoute'])
  .component('queueList', react2angular(QueueList))
  .component('loading', react2angular(Loading))
  .component(
    'queuePreferencesModal',
    react2angular(QueuePreferencesModal, undefined, ['$rootScope']),
  )
  .component('brokerageGrouping', react2angular(BrokerageGrouping))
  .component(
    'mlsFilterDropdown',
    react2angular(MlsFilterDropdown, [
      'mlsOptions',
      'filteredMlsOptions',
      'setFilteredMlsOptions',
      'positionRelative',
    ]),
  );

require('./answering.service');

require('./brokerages/brokerages_list.component');
require('./queue/answering_queue.component');

require('./answering.routes');
